var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "view-card-skeleton"
  }, [_c('div', {
    staticClass: "view-card-skeleton-inner animated"
  }), _c('div', {
    staticClass: "view-card-skeleton-footer"
  }, [_c('div', {
    staticClass: "view-card-skeleton-chip animated"
  }), _c('div', {
    staticClass: "view-card-skeleton-chip animated"
  }), _c('div', {
    staticClass: "view-card-skeleton-chip animated"
  })])]);
}];
export { render, staticRenderFns };